import { Injectable } from '@angular/core';

@Injectable()
export class Experience {
    ExperienceID:string;
    StartDate:string;
    StopDate:string;
    CompanyName:string;
    Position:string;
    Salary:string;
    ApplyJobID:string;
}


// WEBPACK FOOTER //
// ./src/app/experience.ts